export function loadHtmlImage(src: string, cors = true): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    if (cors && !src.startsWith('blob:') && !src.startsWith('data:')) {
      img.crossOrigin = 'anonymous';
    }
    img.onload = () => resolve(img);
    img.onerror = () =>
      reject(new Error('No se pudo cargar la imagen. Si ya está en el catálogo, prueba descargarla y subirla de nuevo.'));
    img.src = src;
  });
}

export async function loadImageFromFile(file: File): Promise<HTMLImageElement> {
  const url = URL.createObjectURL(file);
  try {
    return await loadHtmlImage(url, false);
  } finally {
    // Keep the object URL alive while the HTMLImageElement uses it.
  }
}

export function imageToBuffer(
  img: HTMLImageElement,
  maxSide = 1280
): { width: number; height: number; data: Uint8ClampedArray } {
  const nw = img.naturalWidth || img.width;
  const nh = img.naturalHeight || img.height;
  const scale = Math.min(1, maxSide / Math.max(nw, nh, 1));
  const width = Math.max(1, Math.round(nw * scale));
  const height = Math.max(1, Math.round(nh * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas no disponible en este navegador');
  ctx.drawImage(img, 0, 0, width, height);
  return { width, height, data: ctx.getImageData(0, 0, width, height).data };
}

export function bufferToImage(buf: {
  width: number;
  height: number;
  data: Uint8ClampedArray;
}): Promise<HTMLImageElement> {
  const canvas = document.createElement('canvas');
  canvas.width = buf.width;
  canvas.height = buf.height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return Promise.reject(new Error('Canvas no disponible en este navegador'));
  ctx.putImageData(new ImageData(buf.data, buf.width, buf.height), 0, 0);
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error('No se pudo exportar el recorte'));
        return;
      }
      const url = URL.createObjectURL(blob);
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('No se pudo cargar el recorte'));
      img.src = url;
    }, 'image/png');
  });
}
